import React from "react";

const iconPathRegistry = {
    arrow_left: React.lazy(() => import("../IconPaths/arrow_left")),
    arrow_right: React.lazy(() => import("../IconPaths/arrow_right")),
    bell_active: React.lazy(() => import("../IconPaths/bell_active")),
    bell: React.lazy(() => import("../IconPaths/bell")),
    bin: React.lazy(() => import("../IconPaths/bin")),
    bolt: React.lazy(() => import("../IconPaths/bolt")),
    bug: React.lazy(() => import("../IconPaths/bug")),
    calendar: React.lazy(() => import("../IconPaths/calendar")),
    chat: React.lazy(() => import("../IconPaths/chat")),
    chat_bubble: React.lazy(() => import("../IconPaths/chat_bubble")),
    chevron_down: React.lazy(() => import("../IconPaths/chevron_down")),
    chevron_right: React.lazy(() => import("../IconPaths/chevron_right")),
    chevron_up: React.lazy(() => import("../IconPaths/chevron_up")),
    chevron_vertical: React.lazy(() => import("../IconPaths/chevron_vertical")),
    check: React.lazy(() => import("../IconPaths/check")),
    circle_chevron_left: React.lazy(() => import("../IconPaths/circle_chevron_left")),
    circle_chevron_right: React.lazy(() => import("../IconPaths/circle_chevron_right")),
    clipboard: React.lazy(() => import("../IconPaths/clipboard")),
    cross: React.lazy(() => import("../IconPaths/cross")),
    dots_vertical: React.lazy(() => import("../IconPaths/dots_vertical")),
    download: React.lazy(() => import("../IconPaths/download")),
    error_outline: React.lazy(() => import("../IconPaths/error_outline")),
    error: React.lazy(() => import("../IconPaths/error")),
    file_archive: React.lazy(() => import("../IconPaths/file_archive")),
    file_blank_fill: React.lazy(() => import("../IconPaths/file_blank_fill")),
    file_dotted: React.lazy(() => import("../IconPaths/file_dotted")),
    file_image: React.lazy(() => import("../IconPaths/file_image")),
    file_pdf: React.lazy(() => import("../IconPaths/file_pdf")),
    filter_clear: React.lazy(() => import("../IconPaths/filter_clear")),
    filter: React.lazy(() => import("../IconPaths/filter")),
    flag: React.lazy(() => import("../IconPaths/flag")),
    floorplan: React.lazy(() => import("../IconPaths/floorplan")),
    folder_open: React.lazy(() => import("../IconPaths/folder_open")),
    folder: React.lazy(() => import("../IconPaths/folder")),
    grid: React.lazy(() => import("../IconPaths/grid")),
    help_outline: React.lazy(() => import("../IconPaths/help_outline")),
    help: React.lazy(() => import("../IconPaths/help")),
    id_card: React.lazy(() => import("../IconPaths/id_card")),
    info_outline: React.lazy(() => import("../IconPaths/info_outline")),
    info: React.lazy(() => import("../IconPaths/info")),
    key: React.lazy(() => import("../IconPaths/key")),
    line_chart: React.lazy(() => import("../IconPaths/line-chart")),
    list: React.lazy(() => import("../IconPaths/list")),
    log_out: React.lazy(() => import("../IconPaths/log_out")),
    mail: React.lazy(() => import("../IconPaths/mail")),
    map: React.lazy(() => import("../IconPaths/map")),
    map_pin: React.lazy(() => import("../IconPaths/map-pin")),
    menu: React.lazy(() => import("../IconPaths/menu")),
    pencil: React.lazy(() => import("../IconPaths/pencil")),
    phone: React.lazy(() => import("../IconPaths/phone")),
    pin: React.lazy(() => import("../IconPaths/pin")),
    plus: React.lazy(() => import("../IconPaths/plus")),
    wrench: React.lazy(() => import("../IconPaths/wrench")),
    search: React.lazy(() => import("../IconPaths/search")),
    settings: React.lazy(() => import("../IconPaths/settings")),
    sort: React.lazy(() => import("../IconPaths/sort")),
    spinner: React.lazy(() => import("../IconPaths/spinner")),
    stamp: React.lazy(() => import("../IconPaths/stamp")),
    success_outline: React.lazy(() => import("../IconPaths/success_outline")),
    success: React.lazy(() => import("../IconPaths/success")),
    sun: React.lazy(() => import("../IconPaths/sun")),
    user: React.lazy(() => import("../IconPaths/user")),
    users: React.lazy(() => import("../IconPaths/users")),
    warning_outline: React.lazy(() => import("../IconPaths/warning_outline")),
    warning: React.lazy(() => import("../IconPaths/warning")),
    application_control: React.lazy(() => import("../IconPaths/application_control")),
    insect_control: React.lazy(() => import("../IconPaths/insect_control")),
    rodenticides: React.lazy(() => import("../IconPaths/rodenticides")),
    insecticides: React.lazy(() => import("../IconPaths/insecticides")),
    application_equipment: React.lazy(() => import("../IconPaths/application_equipment")),
    disinfectants: React.lazy(() => import("../IconPaths/disinfectants")),
    weed_control: React.lazy(() => import("../IconPaths/weed_control")),
};

export default iconPathRegistry;
